import React from 'react';

interface XPProgressBarProps {
  currentXP: number;
  requiredXP: number;
  level: number;
}

const XPProgressBar: React.FC<XPProgressBarProps> = ({ currentXP, requiredXP, level }) => {
  const progressPercentage = Math.min((currentXP / requiredXP) * 100, 100);

  return (
    <div className="relative w-full max-w-md">
      {/* Level Badge */}
      <div className="absolute -left-2 -top-2 bg-orange-500 text-gray-900 rounded-full w-8 h-8 flex items-center justify-center text-sm font-bold z-10">
        {level}
      </div>
      
      {/* Progress Bar Container */}
      <div className="h-6 bg-gray-700 rounded-full overflow-hidden mt-2">
        {/* Progress Bar Fill */}
        <div 
          className="h-full bg-orange-500 transition-all duration-300 ease-out"
          style={{ width: `${progressPercentage}%` }}
        />
      </div>
      
      {/* XP Counter */}
      <div className="text-sm text-gray-300 mt-1 text-center">
        {currentXP} / {requiredXP} XP
      </div>
    </div>
  );
};

export default XPProgressBar; 